import {
  Input,
  Inject,
  OnInit,
  Directive,
  HostListener,
} from 'ng-metadata/core';

import { DialogService } from 'services/dialog.service';



/**
 * Triggers open a Material dialog with the How It Works rotator
 */
@Directive({
  selector: '[gw-hiw-open]',
})
export class HowItWorksOpenDirective {

  constructor(
    @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
    @Inject(DialogService) private dialogService: DialogService,
  ) {}

  @HostListener('click', ['$event'])
  onClick($event) {
    // Close drops if any is open
    this.$rootScope.$broadcast('gw-close-drop');

    try {
      const dialog = this.dialogService.openHowItWorks($event);
    } catch (e) {}
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/hiw-open.directive.ts